// extracted by mini-css-extract-plugin
module.exports = {"Container":"Logo__Container___9_teB","Image":"Logo__Image___eJ_G_","NoText":"Logo__NoText___2JFKk","SidebarOpen":"Logo__SidebarOpen___2MhXJ"};